'use client'
import Image from 'next/image'
import image from '../../../../public/images/ledventure-contact-us.webp'
import {useEffect, useState} from 'react'
import FadeUpOnVisible from '@/animations/FadeUpOnVisible'

const STARTING_ANGLE = 14
const ENDING_ANGLE = 12

const Hero = () => {
  const [angle, setAngle] = useState(-STARTING_ANGLE)

  useEffect(() => {
    const maxScroll = 100
    const handleScroll = () => {
      const scroll = window.scrollY
      if (scroll > maxScroll * 3) return

      const progress = Math.min(scroll / maxScroll, 1)

      setAngle(-(STARTING_ANGLE - (STARTING_ANGLE - ENDING_ANGLE) * progress))
    }

    handleScroll()

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <FadeUpOnVisible className="col-span-4 pb-8 pt-10 md:col-span-6 md:col-start-2 lg:col-span-12 lg:pb-16 lg:pt-32">
      <h1 className="flex flex-col items-center text-center text-display-sm lg:text-display-xl">
        <Image
          src={image}
          placeholder="blur"
          alt="About image"
          sizes="(max-width: 767px) 100vw, (max-width: 1439px) 50vw, 33vw"
          style={{transform: `rotate(${angle}deg)`}}
          className="col-span-4 mb-6 h-[86px] w-[154px] object-cover transition-transform duration-1000 ease-out md:-mb-1 lg:-mb-3 lg:h-[173px] lg:w-[308px]"
        />
        <div className="flex flex-col md:flex-row md:gap-x-40 lg:gap-x-56">
          <span>LET&apos;S</span>
          <span>ELEVATE</span>
        </div>
        <span>YOUR GAME</span>
      </h1>
    </FadeUpOnVisible>
  )
}

export default Hero
